<!-- Loading Spinner -->
@if (isLoading) {
<div class="d-flex justify-content-center align-items-center py-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
}

<!-- Search Bar -->
@if (!isLoading) {
<div class="d-flex justify-content-between booking-id-search mb-0 align-items-center">
  <div>
    <h6 for="bookingId" class="form-label">Booking View @if(bookingId){ - <span class="badge-booking-id">{{ bookingId
        }}</span>}</h6>
    <!-- <div class="breadcrumb-container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active" aria-current="page">Logs:</li>
          <li class="breadcrumb-item active">Action: </li>
        </ol>
      </nav>
    </div> -->
  </div>
  <div>
    <div class="input-group mb-1">
      <input type="text" class="form-control" placeholder="Search by booking ID..." [(ngModel)]="bookingId">
      <button class="btn btn-primary" type="button" (click)="onSearch()">
        <i class="fa fa-search"></i>
      </button>
    </div>
    <!-- <div class="text-end mt-1">
      <h6 class="mb-0">{{ bookingId }}</h6>
    </div> -->
  </div>
</div>
}

<!-- Tabbed Logs -->
@if (!isLoading) {
<div>
  @for (objectId of (groupedLogs | keyvalue); track objectId) {
  <div>
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs custom-tabs mb-1">
      <li [ngbNavItem]="1">
        <a ngbNavLink><i class="fa fa-plus-square-o" aria-hidden="true"></i>
          CREATE</a>
        <ng-template ngbNavContent>
          @for (log of objectId.value; track log) {
          @if (log.action === 'CREATE') {
          <div class="col-md-12 mb-3">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <p class="card-text mb-1">
                  <i class="fa fa-calendar-plus-o text-primary me-1" aria-hidden="true"></i>
                  <strong>Created At:</strong> {{ log.created_at | timezone }}
                </p>
                <p class="card-text mb-1">
                  <i class="fa fa-user-plus text-success me-1" aria-hidden="true"></i>
                  <strong>Created By:</strong> {{ log.created_by }}
                </p>
                <div class="card-text">
                  <div class="bg-light rounded mt-1">
                    <app-create-view [logData]="bookingCreate"></app-create-view>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          }
          @if(!bookingCreate){
          <div class="d-flex flex-column justify-content-center align-items-center" style="height: 120px;">
            <i class="fa fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
            <span class="text-muted">No logs found</span>
          </div>
          }
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          UPDATE</a>
        <ng-template ngbNavContent>
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Updated At</th>
                <th>Updated By</th>
                <th>Changes</th>
              </tr>
            </thead>
            <tbody>
              @for (log of bookingUpdates; track log) {
              @if (log.action === 'UPDATE') {
              <tr class="">
                <td>{{ log.updated_at | timezone }}</td>
                <td>
                  {{ log.updated_by }}
                  @if(log.updated_by === 'Task'){
                  <ng-container>- {{ log.task_source }}</ng-container>
                  }
                </td>
                <td>
                  <pre><app-update-view [logData]="log.changed_fields"></app-update-view></pre>
                </td>
              </tr>
              }
              }
            </tbody>
          </table>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
  }
  @if(!isLoading && (logData.length === 0 || !logData)){
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 120px;">
    <i class="fa fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
    <span class="text-muted">No logs found</span>
  </div>
  }
</div>
}